import React, { useState } from "react";
import { format } from 'date-fns';
import "../Modals.css";
import "./AssigningScores.css";
import { test, studentSubmissions,gradedSubmissions } from "../../../Status";
const AssigningScores = ({ setAssignScore, Student }) => {
    const formattedDate = format(new Date(), 'dd/MM/yyyy');
    const handleCorrection = () =>{
        if (Feedback===''){
            alert(                        "You have to write something in the feeback section !"
)
        }
        else {
            setAssignScore(0)
            studentSubmissions.splice(studentSubmissions.findIndex(u => u === Student), 1);
  gradedSubmissions.push({
    student: {
      name: Student.studentName,
      profileLink: Student.profileLink
    },
    submissionType: Student.submissionType,
    corrector: {
      name: test.name,
      profileLink: "/staff/smith"
    },
    correctionDate: formattedDate,
    submission: {
      downloadLink: Student.downloadLink,
      originalDate: Student.submissionDate
    },
    score: Score,
    feedback: Feedback});
        }
    }

  const [Score, setScore] = useState(0);
  const [Feedback, setFeedback] = useState("");
  return (
    <div className="AssigningScores Modal-Container">
      <div className="Modal AssiningScoresModal">
        <div className="Headding">
          <h1>Adding to Archive</h1>
          <span className="close-btn" onClick={() => setAssignScore(0)}>
            &times;
          </span>
        </div>
        <div className="AssingingScoreForm">
          <div className="SubmissionReferences">
            <span>
              <b>Reference : </b>
              {Student.Number}
            </span>
            <span>
              <b>Student : </b>
              {Student.studentName}
            </span>
            <span>
              <b>Submission Type : </b>
              {Student.submissionType}
            </span>
          </div>
          <div className="CorrectorsSection">
            <div className="Score">
              <span htmlFor="">Score to Assign : </span>{" "}
              <input
                onChange={(e) => setScore(e.target.value)}
                type="number"
                min={0}
                step={1}
                defaultValue={0}
              />
            </div>
            <div className="Feedback">
              <span htmlFor="">Feedback to student : </span>

              <textarea
                onChange={(e) => setFeedback(e.target.value)}
                type="text"
                name=""
                id=""
              ></textarea>
            </div>
            <div className="button">
              <span>
                <b>Signature :</b> {test.name}
              </span>
              <button
                onClick={() =>handleCorrection()
                }
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssigningScores;
